if (!customElements.get('results-grid')) {
  customElements.define(
    'results-grid',
    class ResultsGrid extends HTMLElement {
      constructor () {
        super()
        this.eventBus = window.theme.results.eventBus
        this.events = window.theme.results.events
      }

      connectedCallback () {
        this._onProductsUpdated = this.renderProducts.bind(this)
        this.eventBus.subscribe(
          window.theme.results.events.STATE.PRODUCTS_UPDATED,
          this._onProductsUpdated,
        )
      }

      disconnectedCallback () {
        this.eventBus.unsubscribe(
          window.theme.results.events.STATE.PRODUCTS_UPDATED,
          this._onProductsUpdated,
        )
      }

      handleProductCardClick (event) {
        const productCard = event.target.closest('.prd-Card')
        const target = event.target?.href || false
        if (!productCard || !target) return

        this.eventBus.publish(this.events.TRACKING.PRODUCT_CLICKED, {
          productId: productCard.getAttribute('data-product-id'),
          productUrl: productCard.getAttribute('data-product-url'),
        })
      }

      handleProductCardSubmit (event) {
        this.eventBus.publish(this.events.TRACKING.PRODUCT_ADDED_TO_CART, {
          productId: event.target.closest('.prd-Card').getAttribute('data-product-id'),
          productUrl: event.target.closest('.prd-Card').getAttribute('data-product-url'),
        })
      }

      renderProducts ({ products, interaction }) {
        const list = this.querySelector('[data-results-grid-el="list"]')
        const items = list.querySelectorAll('.prd-List_Item')
        const totalItems = products.length
        const productsPerPage = window.theme.results.stateLayer.state.pagination.productsPerPage

        if (interaction === 'filter' || interaction === 'sort') {
          list.innerHTML = ''
          products.forEach((product, index) => {
            const listItem = document.createElement('li')
            listItem.className = 'prd-List_Item'
            listItem.innerHTML = window.theme.results.templates.ProductCard({ product, index })
            list.appendChild(listItem)
          })
        }

        if (interaction === 'initial') {
          list.style.contentVisibility = 'hidden'

          if (totalItems >= productsPerPage) {
            products.forEach((product, index) => {
              if (!items[index]) return
              items[index].innerHTML = window.theme.results.templates.ProductCard({
                product,
                index,
              })
            })
          } else {
            list.innerHTML = ''
            products.forEach((product, index) => {
              const listItem = document.createElement('li')
              listItem.className = 'prd-List_Item'
              listItem.innerHTML = window.theme.results.templates.ProductCard({ product, index })
              list.appendChild(listItem)
            })
          }
        }

        if (interaction === 'pagination') {
          const fragment = document.createDocumentFragment()
          products.forEach((product, index) => {
            const listItem = document.createElement('li')
            listItem.className = 'prd-List_Item'
            listItem.innerHTML = window.theme.results.templates.ProductCard({ product, index })
            fragment.appendChild(listItem)
          })
          list.appendChild(fragment)
        }

        list.querySelectorAll('.prd-Card').forEach(card => {
          card.addEventListener('click', this.handleProductCardClick.bind(this))
          card
            .querySelector('form')
            .addEventListener('submit', this.handleProductCardSubmit.bind(this))
        })

        list.style.contentVisibility = ''
        window.dispatchEvent(
          new CustomEvent('bao:modules:reinit', {
            detail: {
              root: list,
            },
          }),
        )
      }
    },
  )
}
